import { z } from 'zod';

export const revenueExpenseReportSchema = z.object({});

export type EditPrintTemplateTableType = object;

export const editPrintTemPlateSchema = z.object({});

export type EditPrintTemplateFormValues = z.infer<typeof editPrintTemPlateSchema>;

export const searchSchema = z.object({
  ma_tinh: z.string().min(1, 'Mã tỉnh/thành là bắt buộc'),
  ten_tinh: z.string().min(1, 'Tên tỉnh/thành là bắt buộc'),
  ten_tinh2: z.string().optional().nullable(),
  trang_thai: z.number().default(1)
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export interface ProvinceFormattedData {
  ma_tinh: string;
  ten_tinh: string;
  ten_tinh2: string | null;
  status: string;
}
